import ReactEChartsCore from 'echarts-for-react/lib/core';
import { ChartContainer } from '../../analytics/shared/ChartContainer';
import { EmptyState } from '../../analytics/shared/EmptyState';
import { echarts } from '../../analytics/shared/echarts-config';
import type {
  EngagementMetricsEngagementFunnel,
  EngagementMetricsProfileViewFunnel,
} from '../../../types/engagement-metrics.types';

type EngagementFunnelChartsProps = {
  profileViewFunnel: EngagementMetricsProfileViewFunnel;
  engagementFunnel: EngagementMetricsEngagementFunnel;
};

const FUNNEL_COLORS = ['#15543e', '#2f7d5e', '#5d8b76', '#aab2ab'];

const buildFunnelOptions = (stages: Array<{ label: string; count: number }>) => ({
  tooltip: { trigger: 'item' as const, formatter: '{b}: {c}' },
  series: [
    {
      type: 'funnel' as const,
      left: '6%',
      right: '6%',
      top: 10,
      bottom: 10,
      width: '88%',
      minSize: '30%',
      maxSize: '100%',
      sort: 'none' as const,
      gap: 2,
      label: {
        show: true,
        position: 'inside' as const,
        formatter: '{b}\n{c}',
        color: '#fff',
        fontWeight: 700,
        fontSize: 11,
      },
      itemStyle: { borderColor: '#fff', borderWidth: 1 },
      data: stages.map((stage, index) => ({
        name: stage.label,
        value: stage.count,
        itemStyle: { color: FUNNEL_COLORS[index % FUNNEL_COLORS.length] },
      })),
    },
  ],
});

export const EngagementFunnelCharts = ({
  profileViewFunnel,
  engagementFunnel,
}: EngagementFunnelChartsProps) => {
  const hasProfileViewData = profileViewFunnel.stages.some((stage) => stage.count > 0);
  const hasEngagementData = engagementFunnel.stages.some((stage) => stage.count > 0);

  return (
    <div className="grid grid-cols-1 gap-3.5 lg:grid-cols-2">
      <ChartContainer
        title="Profile View → Billable Conversion"
        subtitle={`${profileViewFunnel.conversionPercent}% of profile views convert to billable engagements`}
      >
        {hasProfileViewData ? (
          <ReactEChartsCore
            echarts={echarts}
            option={buildFunnelOptions(profileViewFunnel.stages)}
            style={{ height: 260 }}
            notMerge
            lazyUpdate
          />
        ) : (
          <EmptyState message="No profile-view conversion data available." />
        )}
      </ChartContainer>

      <ChartContainer
        title="Engagement Funnel"
        subtitle="First messages → consultation requests → referrals"
      >
        {hasEngagementData ? (
          <ReactEChartsCore
            echarts={echarts}
            option={buildFunnelOptions(engagementFunnel.stages)}
            style={{ height: 260 }}
            notMerge
            lazyUpdate
          />
        ) : (
          <EmptyState message="No engagement funnel data available." />
        )}
      </ChartContainer>
    </div>
  );
};
